import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=5850bcbd&"
import script from "./filters.vue?vue&type=script&lang=js&"
export * from "./filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports